var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.activeMenuName)),_c('Icon',{staticClass:"ico-help",attrs:{"type":"md-help-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }